/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Addentry2Inputs */

const en_coinvestments_report_addentry2 = /** @type {(inputs: Coinvestments_Report_Addentry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add entry`)
};

/**
* | output |
* | --- |
* | "Add entry" |
*
* @param {Coinvestments_Report_Addentry2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_addentry2 = /** @type {((inputs?: Coinvestments_Report_Addentry2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Addentry2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_addentry2(inputs)
});
export { coinvestments_report_addentry2 as "coInvestments_report_addEntry" }